import { produce } from 'immer';
import { RemoteRecordData } from 'b2b-apps/shop/common/redux/RemoteRecordData';
import {
  CLEAR_PRODUCT_TILES,
  FETCH_PRODUCT_TILE,
  FETCH_PRODUCT_TILE_FULFILLED,
  FETCH_PRODUCT_TILE_REJECTED,
  FETCH_PRODUCT_TILES,
  FETCH_PRODUCT_TILES_FULFILLED,
  FETCH_PRODUCT_TILES_REJECTED,
} from 'b2b-apps/shop/product/redux/products/tile/actionTypes';
import {
  ProductTilesActions,
  ProductTilesState,
} from 'b2b-apps/shop/product/redux/products/tile/types';

const initialState: ProductTilesState = {};

const reducer = (
  state: ProductTilesState = initialState,
  action: ProductTilesActions,
): ProductTilesState => {
  switch (action.type) {
    case CLEAR_PRODUCT_TILES:
      return initialState;

    case FETCH_PRODUCT_TILE:
      return produce(state, (draft: ProductTilesState) => {
        draft[action.payload.sku] = RemoteRecordData.init();
      });

    case FETCH_PRODUCT_TILE_FULFILLED:
      return produce(state, (draft: ProductTilesState) => {
        draft[action.payload.sku] = RemoteRecordData.fulfill(
          action.payload.data,
        );
      });

    case FETCH_PRODUCT_TILE_REJECTED:
      return produce(state, (draft: ProductTilesState) => {
        draft[action.payload.sku] = RemoteRecordData.reject(
          action.payload.error,
        );
      });

    case FETCH_PRODUCT_TILES:
      return produce(state, (draft: ProductTilesState) => {
        action.payload.skus.map(
          (sku) => (draft[sku] = RemoteRecordData.init()),
        );
      });

    case FETCH_PRODUCT_TILES_FULFILLED:
      return produce(state, (draft: ProductTilesState) => {
        action.payload.skus.map(
          (sku) => (draft[sku] = RemoteRecordData.fulfill(action.payload.data[sku])),
        );
      });

    case FETCH_PRODUCT_TILES_REJECTED:
      return produce(state, (draft: ProductTilesState) => {
        action.payload.skus.map(
          (sku) => (draft[sku] = RemoteRecordData.reject(action.payload.error)),
        );
      });

    default:
      return state;
  }
};

export { reducer };
